
/**
 * 프로젝트 댓글 생성 요청
 */
export type CreateProjectCommentBody = {
  /** 댓글 내용 */
  content: string;
  /**
   * 부모 댓글 ID (답글일 경우)
   * @nullable
   */
  parentId?: string | null;
};
